import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreUserProfileRoomToken } from '../firestore/UserProfileRoomToken/schema'
import { empty } from '../firestore/UserProfileRoomToken/schema'

export class UserProfileRoomToken extends ObservableModelWithDecorators<FirestoreUserProfileRoomToken> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileRoomToken>
  ) {
    super(repository, doc)
  }
}
